import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import { stockMovementService } from "services/stockMovement.service";
import authStore from "stores/auth/AuthStore";
import {
  BulkStockMovementRequest,
  StockMovementAttributes,
  StockMovementResponse,
  StockMovementStats,
} from "types/stockMovement.type";

class StockMovementStore {
  movements: StockMovementAttributes[] = [];
  stats: StockMovementStats | null = null;
  loadingFetch = false;
  loadingAction = false;
  loadingStats = false;
  total: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchMovements(
    page: number = 1,
    limit: number = 10,
    filters: Record<string, any> = {}
  ) {
    if (!authStore.isAuthenticated()) return;

    this.loadingFetch = true;
    try {
      const data: StockMovementResponse = await stockMovementService.getAll(
        page,
        limit,
        filters
      );
      runInAction(() => {
        this.movements = data.data;
        this.total = data.total;
      });
    } catch (error: any) {
      toast.error("Erreur lors du chargement des mouvements de stock");
    } finally {
      runInAction(() => {
        this.loadingFetch = false;
      });
    }
  }

  async fetchStats() {
    if (!authStore.isAuthenticated()) return;
    this.loadingStats = true;

    try {
      const res = await stockMovementService.getStats();
      runInAction(() => {
        this.stats = res;
      });
    } catch (error: any) {
      toast.error(
        error.response?.data?.message ||
          "Erreur lors du chargement des statistiques"
      );
    } finally {
      runInAction(() => {
        this.loadingStats = false;
      });
    }
  }

  async createBulkMovement(
    data: BulkStockMovementRequest,
    onSuccess?: () => void
  ) {
    this.loadingAction = true;
    try {
      const response = await stockMovementService.createBulk(data);
      toast.success(response.message);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error: any) {
      throw error;
    } finally {
      runInAction(() => {
        this.loadingAction = false;
      });
    }
  }
}

const stockMovementStore = new StockMovementStore();
export default stockMovementStore;
